<template>
  <el-row>
    <el-card shadow="never" class="mt-0 card-promo">
      <el-radio-group
        v-model="Promo.promoTargetPushCart.target.targetType"
        style="width: 100%"
      >
        <template v-for="(formradio, idx) in formRadio">
          <el-row :key="idx" type="flex" justify="space-between">
            <el-col :span="6">
              <el-radio :label="formradio.value" class="mt-2">{{
                formradio.label
              }}</el-radio>
            </el-col>
            <el-col :span="14">
              <el-form-item size="small" style="margin: 0">
                <el-row
                  type="flex"
                  justify="space-between"
                  style="flex-wrap: wrap"
                >
                  <template v-for="(form, idx) in formradio.form">
                    <el-col
                      :span="form.span"
                      style="margin-bottom: 18px"
                      :key="idx"
                    >
                      <el-select
                        v-model="Promo.promoTargetPushCart.target[form.id]"
                        :placeholder="form.placeholder"
                        style="width: 100%"
                        filterable
                        remote
                        :remote-method="form.onSearch"
                        :loading="form.onLoading"
                        :disabled="disabledField(formradio.value)"
                      >
                        <el-option
                          v-for="item in form.data"
                          :key="item.value"
                          :label="item.name"
                          :value="item.value"
                        ></el-option>
                        <el-row type="flex" justify="center">
                          <el-button
                            :loading="form.onLoading"
                            size="mini"
                            round
                            @click="form.loadMore"
                            >Load More</el-button
                          >
                        </el-row>
                      </el-select>
                    </el-col>
                  </template>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </el-radio-group>
    </el-card>
  </el-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: ["Promo"],
  data() {
    return {
      limitProduct: 25,
    };
  },
  computed: {
    ...mapState({
      products: state => state.product.products
    }),
    formRadio() {
      return [
        {
          label: "Oracle Item ID",
          value: "oracleItemId",
          form: [
            {
              type: "select",
              id: "oracleItemId",
              label: "",
              rules: [],
              placeholder: "Select Item",
              data: this.products.data.map(item => {
                item.name = item.itemName;
                item.value = item.itemCode;
                return item;
              }),
              loadMore: this.loadMoreProduct,
              onSearch: this.onSearchProduct,
              onLoading: this.products.isLoading
            },
          ]
        }
      ];
    }
  },
  methods: {
    ...mapActions({
      getProducts: "product/GetProducts",
    }),
    disabledField(value) {
      return this.Promo.promoTargetPushCart.target.targetType !== value
    },
    onSearchProduct(search) {
      let option = {
        params: {
          page: 1,
          limit: 25,
          search: search
        }
      };
      this.getProducts(option);
    },
    loadMoreProduct() {
      this.limitProduct += 25;
      let option = {
        params: {
          page: 1,
          limit: this.limitProduct,
        }
      };
      this.getProducts(option);
    },
  },
  created() {
    let option = {
      params: {
        page: 1,
        limit: 25
      }
    };
    this.getProducts(option);
  }
};
</script>

<style>
.tab-promo /deep/ .el-tabs__item {
  padding: 0px 20px !important;
}
.tab-promo /deep/ .el-tabs__item.is-active {
  color: white !important;
  background-color: #2356c9;
  padding: 0px 20px !important;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  font-weight: bold;
}
.tab-promo /deep/ .el-tabs__header.is-top {
  margin: 0 !important;
}
.card-promo {
  background-color: #f6f6f6 !important;
}
</style>
